export var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
    Gender["UNKNOWN"] = "UNKNOWN";
})(Gender || (Gender = {}));
export var GenderDeterminationMethod;
(function (GenderDeterminationMethod) {
    GenderDeterminationMethod["SURGICAL_SEXING"] = "SS";
    GenderDeterminationMethod["DNA_SEXING"] = "DNA";
    GenderDeterminationMethod["VISUALLY_SEXED"] = "VS";
    GenderDeterminationMethod["NOT_SEXED"] = "NS";
})(GenderDeterminationMethod || (GenderDeterminationMethod = {}));
export var BirdStatus;
(function (BirdStatus) {
    BirdStatus["AVAILABLE"] = "AVAILABLE";
    BirdStatus["PAIRED"] = "PAIRED";
    BirdStatus["FOR_SALE"] = "FOR_SALE";
    BirdStatus["DECEASED"] = "DECEASED";
    BirdStatus["LOST"] = "LOST";
    BirdStatus["DONATED"] = "DONATED";
})(BirdStatus || (BirdStatus = {}));
export var HealthStatus;
(function (HealthStatus) {
    HealthStatus["EXCELLENT"] = "EXCELLENT";
    HealthStatus["GOOD"] = "GOOD";
    HealthStatus["FAIR"] = "FAIR";
    HealthStatus["POOR"] = "POOR";
    HealthStatus["CRITICAL"] = "CRITICAL";
    HealthStatus["SICK"] = "SICK";
    HealthStatus["UNDER_OBSERVATION"] = "UNDER_OBSERVATION";
    HealthStatus["RECOVERING"] = "RECOVERING";
    HealthStatus["QUARANTINE"] = "QUARANTINE";
    HealthStatus["UNKNOWN"] = "UNKNOWN";
})(HealthStatus || (HealthStatus = {}));
export var VaccinationStatus;
(function (VaccinationStatus) {
    VaccinationStatus["UP_TO_DATE"] = "UP_TO_DATE";
    VaccinationStatus["OVERDUE"] = "OVERDUE";
    VaccinationStatus["PARTIAL"] = "PARTIAL";
    VaccinationStatus["NOT_STARTED"] = "NOT_STARTED";
    VaccinationStatus["UNKNOWN"] = "UNKNOWN";
})(VaccinationStatus || (VaccinationStatus = {}));
export var EggStatus;
(function (EggStatus) {
    EggStatus["LAID"] = "LAID";
    EggStatus["INCUBATING"] = "INCUBATING";
    EggStatus["HATCHED"] = "HATCHED";
    EggStatus["FLEDGED"] = "FLEDGED";
    EggStatus["BANDED"] = "BANDED";
    EggStatus["NOT_FERTILIZED"] = "NOT_FERTILIZED";
    EggStatus["BROKEN"] = "BROKEN";
    EggStatus["ABANDONED"] = "ABANDONED";
    EggStatus["DEAD_IN_SHELL"] = "DEAD_IN_SHELL";
    EggStatus["DEAD_BEFORE_BANDING"] = "DEAD_BEFORE_BANDING";
})(EggStatus || (EggStatus = {}));
export var ChickRearMethod;
(function (ChickRearMethod) {
    ChickRearMethod["PARENT_REARED"] = "PARENT_REARED";
    ChickRearMethod["HAND_REARED"] = "HAND_REARED";
    ChickRearMethod["FOSTER_REARED"] = "FOSTER_REARED";
})(ChickRearMethod || (ChickRearMethod = {}));
export var IUCNStatus;
(function (IUCNStatus) {
    IUCNStatus["LEAST_CONCERN"] = "LC";
    IUCNStatus["NEAR_THREATENED"] = "NT";
    IUCNStatus["VULNERABLE"] = "VU";
    IUCNStatus["ENDANGERED"] = "EN";
    IUCNStatus["CRITICALLY_ENDANGERED"] = "CR";
    IUCNStatus["EXTINCT_IN_WILD"] = "EW";
    IUCNStatus["EXTINCT"] = "EX";
    IUCNStatus["DATA_DEFICIENT"] = "DD";
    IUCNStatus["NOT_EVALUATED"] = "NE";
})(IUCNStatus || (IUCNStatus = {}));
export var CITESStatus;
(function (CITESStatus) {
    CITESStatus["APPENDIX_I"] = "I";
    CITESStatus["APPENDIX_II"] = "II";
    CITESStatus["APPENDIX_III"] = "III";
    CITESStatus["NOT_LISTED"] = "NL";
})(CITESStatus || (CITESStatus = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType["HEALTH_CERTIFICATE"] = "HEALTH_CERTIFICATE";
    DocumentType["VACCINATION_RECORD"] = "VACCINATION_RECORD";
    DocumentType["DNA_SEXING_RESULT"] = "DNA_SEXING_RESULT";
    DocumentType["BREEDING_RECORD"] = "BREEDING_RECORD";
    DocumentType["SALE_RECEIPT"] = "SALE_RECEIPT";
    DocumentType["PURCHASE_RECEIPT"] = "PURCHASE_RECEIPT";
    DocumentType["TRANSFER_DOCUMENT"] = "TRANSFER_DOCUMENT";
    DocumentType["CITES_PERMIT"] = "CITES_PERMIT";
    DocumentType["OTHER"] = "OTHER";
})(DocumentType || (DocumentType = {}));
export var Provenance;
(function (Provenance) {
    Provenance["BRED_ON_SITE"] = "BRED_ON_SITE";
    Provenance["PURCHASED"] = "PURCHASED";
    Provenance["DONATED"] = "DONATED";
    Provenance["RESCUE"] = "RESCUE";
    Provenance["TRADE"] = "TRADE";
    Provenance["UNKNOWN"] = "UNKNOWN";
})(Provenance || (Provenance = {}));
export var HealthRecordType;
(function (HealthRecordType) {
    HealthRecordType["VACCINATION"] = "VACCINATION";
    HealthRecordType["HEALTH_CHECK"] = "HEALTH_CHECK";
    HealthRecordType["TREATMENT"] = "TREATMENT";
    HealthRecordType["TEST_RESULT"] = "TEST_RESULT";
    HealthRecordType["MEDICATION"] = "MEDICATION";
    HealthRecordType["INJURY"] = "INJURY";
    HealthRecordType["ILLNESS"] = "ILLNESS";
    HealthRecordType["OTHER"] = "OTHER";
})(HealthRecordType || (HealthRecordType = {}));
export var ClutchStatus;
(function (ClutchStatus) {
    ClutchStatus["ACTIVE"] = "ACTIVE";
    ClutchStatus["COMPLETED"] = "COMPLETED";
    ClutchStatus["ABANDONED"] = "ABANDONED";
    ClutchStatus["TERMINATED"] = "TERMINATED";
})(ClutchStatus || (ClutchStatus = {}));
export var BreedingStatus;
(function (BreedingStatus) {
    BreedingStatus["ACTIVE"] = "ACTIVE";
    BreedingStatus["PAUSED"] = "PAUSED";
    BreedingStatus["COMPLETED"] = "COMPLETED";
    BreedingStatus["TERMINATED"] = "TERMINATED";
})(BreedingStatus || (BreedingStatus = {}));
export var FeedStockStatus;
(function (FeedStockStatus) {
    FeedStockStatus["IN_STOCK"] = "IN_STOCK";
    FeedStockStatus["LOW_STOCK"] = "LOW_STOCK";
    FeedStockStatus["OUT_OF_STOCK"] = "OUT_OF_STOCK";
})(FeedStockStatus || (FeedStockStatus = {}));
export var TaskType;
(function (TaskType) {
    TaskType["BREEDING"] = "BREEDING";
    TaskType["HEALTH_CHECK"] = "HEALTH_CHECK";
    TaskType["BANDING"] = "BANDING";
    TaskType["FEEDING"] = "FEEDING";
    TaskType["MAINTENANCE"] = "MAINTENANCE";
    TaskType["GENERAL"] = "GENERAL";
    TaskType["OTHER"] = "OTHER";
})(TaskType || (TaskType = {}));
export var TaskPriority;
(function (TaskPriority) {
    TaskPriority["LOW"] = "LOW";
    TaskPriority["MEDIUM"] = "MEDIUM";
    TaskPriority["HIGH"] = "HIGH";
    TaskPriority["URGENT"] = "URGENT";
})(TaskPriority || (TaskPriority = {}));
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["PENDING"] = "PENDING";
    TaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TaskStatus["COMPLETED"] = "COMPLETED";
    TaskStatus["CANCELLED"] = "CANCELLED";
    TaskStatus["OVERDUE"] = "OVERDUE";
})(TaskStatus || (TaskStatus = {}));
